import React, { useContext } from "react";
import useSWR from "swr";
import { AppContext } from "../containers/All";
import Review from "./Review";

const fetcher = (...args) => fetch(...args).then((r) => r.json());

const NoReviews = ({ state, noReviewsText, page }) => {
  if (noReviewsText) {
    return null;
  }
  if (state === "cancelled") {
    return "There are no reviews yet.";
  } else {
    return "There are no reviews yet-- you can be the first!";
  }
};

const ReviewList = ({
  merchant,
  hidePlatform = false,
  truncateText,
  truncateAt,
  expandInline,
  truncateDest,
  state,
  noReviewsText = false,
  hideResponses,
  page,
  filter = null,
  limit = 10,
  lastPage,
  randomize = false,
  thirdParty = false,
  skipPagination = false,
  currentLocationReviewsOnly = false,
  ReviewComponent = Review,
}) => {
  let { state: appState, dispatch } = useContext(AppContext);
  appState = appState || { page: 0 };
  const { data } = useSWR(
    `${process.env.REACT_APP_API_HOST}/api/public/v2/merchants/${merchant.id}/reviews.json?limit=${limit}&page=${page}&filter=${filter}&thirdParty=${thirdParty}&randomize=${randomize}&skipPagination=${skipPagination}&currentLocationReviewsOnly=${currentLocationReviewsOnly}`,
    fetcher,
    {
      revalidateOnFocus: false,
      onSuccess: (data) => {
        if(lastPage){
          lastPage(data.lastPage)
        };
        if (dispatch) {
          dispatch({ type: "LOADED_REVIEWS", payload: data.reviews });
        };
      },
    }
  );
  if (!data) {
    return null;
  }

  if (data.reviews.length > 0) {
    return (
      <React.Fragment>
        {data.reviews.map((r) => (
          <ReviewComponent
            {...r}
            key={r.id}
            hidePlatform={hidePlatform}
            truncateDest={truncateDest}
            truncateText={truncateText}
            truncateAt={truncateAt}
            expandInline={expandInline}
            hideResponses={hideResponses}
          />
        ))}
        {!data.lastPage && appState.page === page && (
          <a
            className="dmButtonLink dmWidget dmWwr default dmOnlyButton dmDefaultGradient"
            data-display-type="block"
            onClick={() => dispatch({ type: "LOAD_MORE" })}
          >
            <span className="text">Load More</span>
          </a>
        )}
      </React.Fragment>
    );
  } else {
    return <NoReviews state={state} noReviewsText={page === 1 ? noReviewsText : true} page={page} />;
  }
};

export default ReviewList;



// WEBPACK FOOTER //
// ./src/components/ReviewList.jsx